/**
 * @generated SignedSource<<d505fbc7ce362473b0fbc451416d6ded>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type SortEnumType = "ASC" | "DESC" | "%future added value";
export type AllSkillsFilterInput = {
  isActive?: boolean | null | undefined;
  skillCode?: string | null | undefined;
  skillName?: string | null | undefined;
  skillType?: string | null | undefined;
  standardGradeIds?: ReadonlyArray<string> | null | undefined;
  targetGroupIds?: ReadonlyArray<string> | null | undefined;
  targetIds?: ReadonlyArray<string> | null | undefined;
};
export type SkillSortInput = {
  assessmentInfo?: SortEnumType | null | undefined;
  code?: SortEnumType | null | undefined;
  context?: SortEnumType | null | undefined;
  createdBy?: UserSortInput | null | undefined;
  createdOn?: SortEnumType | null | undefined;
  difficulty?: SortEnumType | null | undefined;
  essentialQuestion?: SortEnumType | null | undefined;
  id?: SortEnumType | null | undefined;
  isActive?: SortEnumType | null | undefined;
  lessonInfo?: SortEnumType | null | undefined;
  mapCutoffScore?: SortEnumType | null | undefined;
  modifiedBy?: UserSortInput | null | undefined;
  modifiedOn?: SortEnumType | null | undefined;
  name?: SortEnumType | null | undefined;
  progressionNotes?: SortEnumType | null | undefined;
  summary?: SortEnumType | null | undefined;
};
export type UserSortInput = {
  createdBy?: UserSortInput | null | undefined;
  createdOn?: SortEnumType | null | undefined;
  email?: SortEnumType | null | undefined;
  externalSync?: ExternalSyncSortInput | null | undefined;
  externalSyncId?: SortEnumType | null | undefined;
  firstName?: SortEnumType | null | undefined;
  fullName?: SortEnumType | null | undefined;
  id?: SortEnumType | null | undefined;
  isActive?: SortEnumType | null | undefined;
  isMetabaseAccessEnabled?: SortEnumType | null | undefined;
  isMetabaseEmailEnabled?: SortEnumType | null | undefined;
  isObfuscated?: SortEnumType | null | undefined;
  lastName?: SortEnumType | null | undefined;
  lastNameFirst?: SortEnumType | null | undefined;
  modifiedBy?: UserSortInput | null | undefined;
  modifiedOn?: SortEnumType | null | undefined;
  owner?: UserSortInput | null | undefined;
  publicUserId?: SortEnumType | null | undefined;
};
export type ExternalSyncSortInput = {
  id?: SortEnumType | null | undefined;
  isObfuscated?: SortEnumType | null | undefined;
  lastUpdatedOn?: SortEnumType | null | undefined;
  source?: SortEnumType | null | undefined;
};
export type DiagnosticsAllSkillsQuery$variables = {
  after?: string | null | undefined;
  filter: AllSkillsFilterInput;
  first?: number | null | undefined;
  order?: ReadonlyArray<SkillSortInput> | null | undefined;
  targetGroupsIds?: ReadonlyArray<string> | null | undefined;
};
export type DiagnosticsAllSkillsQuery$data = {
  readonly allSkills: {
    readonly nodes: ReadonlyArray<{
      readonly code: string | null | undefined;
      readonly id: string;
      readonly name: string | null | undefined;
      readonly targetSkills: ReadonlyArray<{
        readonly id: string;
        readonly target: {
          readonly id: string;
          readonly name: string | null | undefined;
          readonly summary: string | null | undefined;
          readonly targetGroup: {
            readonly id: string;
            readonly name: string | null | undefined;
          } | null | undefined;
        } | null | undefined;
        readonly targetSkillType: {
          readonly id: string;
          readonly name: string | null | undefined;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    }> | null | undefined;
    readonly pageInfo: {
      readonly endCursor: string | null | undefined;
      readonly hasNextPage: boolean;
    };
    readonly totalCount: number;
  } | null | undefined;
};
export type DiagnosticsAllSkillsQuery = {
  response: DiagnosticsAllSkillsQuery$data;
  variables: DiagnosticsAllSkillsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filter"
},
v2 = {
  "defaultValue": 100,
  "kind": "LocalArgument",
  "name": "first"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "order"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "targetGroupsIds"
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v7 = [
  (v5/*: any*/),
  (v6/*: any*/)
],
v8 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "after",
        "variableName": "after"
      },
      {
        "kind": "Variable",
        "name": "filter",
        "variableName": "filter"
      },
      {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
      },
      {
        "kind": "Variable",
        "name": "order",
        "variableName": "order"
      }
    ],
    "concreteType": "SkillNodeConnection",
    "kind": "LinkedField",
    "name": "allSkills",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "SkillNode",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "code",
            "storageKey": null
          },
          (v6/*: any*/),
          {
            "alias": null,
            "args": [
              {
                "fields": [
                  {
                    "kind": "Literal",
                    "name": "isActive",
                    "value": "ACTIVE"
                  },
                  {
                    "kind": "Variable",
                    "name": "targetGroupIds",
                    "variableName": "targetGroupsIds"
                  }
                ],
                "kind": "ObjectValue",
                "name": "filter"
              }
            ],
            "concreteType": "TargetSkillNode",
            "kind": "LinkedField",
            "name": "targetSkills",
            "plural": true,
            "selections": [
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "TargetNode",
                "kind": "LinkedField",
                "name": "target",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "summary",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TargetGroupNode",
                    "kind": "LinkedField",
                    "name": "targetGroup",
                    "plural": false,
                    "selections": (v7/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "TargetSkillTypeNode",
                "kind": "LinkedField",
                "name": "targetSkillType",
                "plural": false,
                "selections": (v7/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "totalCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasNextPage",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "endCursor",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "DiagnosticsAllSkillsQuery",
    "selections": (v8/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "DiagnosticsAllSkillsQuery",
    "selections": (v8/*: any*/)
  },
  "params": {
    "cacheID": "4fa78a5d30232d9c9a7b2008495d37d4",
    "id": null,
    "metadata": {},
    "name": "DiagnosticsAllSkillsQuery",
    "operationKind": "query",
    "text": "query DiagnosticsAllSkillsQuery(\n  $filter: AllSkillsFilterInput!\n  $order: [SkillSortInput!]\n  $targetGroupsIds: [ID!]\n  $first: Int = 100\n  $after: String\n) {\n  allSkills(filter: $filter, order: $order, first: $first, after: $after) {\n    nodes {\n      id\n      code\n      name\n      targetSkills(filter: {targetGroupIds: $targetGroupsIds, isActive: ACTIVE}) {\n        id\n        target {\n          id\n          name\n          summary\n          targetGroup {\n            id\n            name\n          }\n        }\n        targetSkillType {\n          id\n          name\n        }\n      }\n    }\n    totalCount\n    pageInfo {\n      hasNextPage\n      endCursor\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "9eeabd93b31653f1706fe1d2252ba51b";

export default node;
